import React from "react";
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { FaRegQuestionCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const P = "features.InvestmentScreening.Popover.improvementTotal";
const C = "common.label";

/**
 * 改善額合計（差異の合計）の項目説明ポップオーバー
 *
 * 使用例:
 * <ImprovementTotalExplanationPopover />
 */
export const ImprovementTotalExplanationPopover: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Popover placement="right">
      <PopoverTrigger>
        <button style={{ background: 'none', border: 'none', padding: 0 }}>
          <FaRegQuestionCircle size="30px" cursor="pointer" />
        </button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent width="600px" maxH="400px" overflowY="auto" bgColor="#fffff0">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader fontWeight="bold">{t(`${P}.title`)}</PopoverHeader>
          <PopoverBody>
            <Table size="sm" variant="simple">
              <Thead>
                <Tr>
                  <Th w="60px">{t(`${C}.no`)}</Th>
                  <Th w="100px">{t(`${C}.item`)}</Th>
                  <Th>{t(`${C}.description`)}</Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td>1</Td>
                  <Td fontWeight="bold">{t(`${P}.scrapCostName`)}</Td>
                  <Td>{t(`${P}.scrapCostDesc`)}</Td>
                </Tr>
                <Tr>
                  <Td>2</Td>
                  <Td fontWeight="bold">{t(`${P}.repairCostName`)}</Td>
                  <Td>{t(`${P}.repairCostDesc`)}</Td>
                </Tr>
                <Tr>
                  <Td>3</Td>
                  <Td fontWeight="bold">{t(`${P}.consumablesCostName`)}</Td>
                  <Td>{t(`${P}.consumablesCostDesc`)}</Td>
                </Tr>
                <Tr>
                  <Td>4</Td>
                  <Td fontWeight="bold">{t(`${P}.totalName`)}</Td>
                  <Td>{t(`${P}.totalDesc`)}</Td>
                </Tr>
              </Tbody>
            </Table>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
